export const hasSurvey = (settings, block) =>
  settings?.features?.survey ||
  (block && settings?.features_by_block?.[block.id]?.survey) ||
  false;
